<div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner *ngIf="isLoading"></mat-spinner>
</div>

<div style="padding: 10px;">
    <div style="padding: 10px; margin-bottom: 10px; text-align: left;">
        <span style="font-size: x-large; font-weight: bold;">Manage Users</span>

        <span style="float:right;">
            <button mat-raised-button color="primary" style="margin-left: 10px;" (click)="addUser()">New User</button>
        </span>
    </div>

    <mat-card appearance="outlined" class="mat-mdc-elevation-specific mat-elevation-z8" style="width: 100%;">
        <div class="table-container">
            <table mat-table
                    matSort
                    [dataSource]="sortedUsers"  
                    [matSortActive]="currentSort.active"
                    [matSortDirection]="currentSort.direction"
                    (matSortChange)="sortUsers($event)">

                <ng-container matColumnDef="userID">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> User ID </th>
                  <td mat-cell *matCellDef="let user"> {{user.user.userID}} </td>
                </ng-container>

                <ng-container matColumnDef="lastName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
                  <td mat-cell *matCellDef="let user"> {{user.user.lastName}} </td>
                </ng-container>

                <ng-container matColumnDef="firstName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
                  <td mat-cell *matCellDef="let user"> {{user.user.firstName}} </td>
                </ng-container>

                <ng-container matColumnDef="roles">
                  <th mat-header-cell *matHeaderCellDef> Roles </th>
                  <td mat-cell *matCellDef="let user"> {{user.roles}} </td>
                </ng-container>

                <ng-container matColumnDef="canImport" style="text-align: center;">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Import Data </th>
                  <td mat-cell *matCellDef="let user" style="text-align: center;"><mat-icon>{{getPermissionIcon(user.user.canImport)}}</mat-icon></td>
                </ng-container>

                <ng-container matColumnDef="canExport" style="text-align: center;">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Export Data </th>
                  <td mat-cell *matCellDef="let user" style="text-align: center;"><mat-icon>{{getPermissionIcon(user.user.canExport)}}</mat-icon></td>
                </ng-container>

                <ng-container matColumnDef="canCreateTable" style="text-align: center;">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Create Tables </th>
                  <td mat-cell *matCellDef="let user" style="text-align: center;"><mat-icon>{{getPermissionIcon(user.user.canCreateTable)}}</mat-icon></td>
                </ng-container>

                <ng-container matColumnDef="canDeleteTable" style="text-align: center;">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Delete Tables </th>
                  <td mat-cell *matCellDef="let user" style="text-align: center;"><mat-icon>{{getPermissionIcon(user.user.canDeleteTable)}}</mat-icon></td>
                </ng-container>

                <ng-container matColumnDef="canAlterTable" style="text-align: center;">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Alter Tables </th>
                  <td mat-cell *matCellDef="let user" style="text-align: center;"><mat-icon>{{getPermissionIcon(user.user.canAlterTable)}}</mat-icon></td>
                </ng-container>

                <ng-container matColumnDef="canViewAuditLogs" style="text-align: center;">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> View Audit Log </th>
                  <td mat-cell *matCellDef="let user" style="text-align: center;"><mat-icon>{{getPermissionIcon(user.user.canViewAuditLogs)}}</mat-icon></td>
                </ng-container>

                <ng-container matColumnDef="canEditUsers" style="text-align: center;">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Edit Users </th>
                  <td mat-cell *matCellDef="let user" style="text-align: center;"><mat-icon>{{getPermissionIcon(user.user.canEditUsers)}}</mat-icon></td>
                </ng-container>

                <ng-container matColumnDef="canEditRoles" style="text-align: center;">
                  <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Edit Roles </th>
                  <td mat-cell *matCellDef="let user" style="text-align: center;"><mat-icon>{{getPermissionIcon(user.user.canEditRoles)}}</mat-icon></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
                <tr mat-row *matRowDef="let row; let i=index; columns: displayedColumns;" class="table-row" (click)="rowClicked(i)"></tr>
            </table>
        </div>
    </mat-card>
</div>
<!-- 'canImport', 'canExport', 'canCreateTable', 'canDeleteTable', 'canAlterTable', 'canViewAuditLogs', 'canEditUsers', 'canEditRoles' -->